var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "24 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default no-stroke",
    transform: "translate(26 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C3 1 1 2.9 1 5.3v8.3C1 16.1 3 18 5.5 18h8c2.5 0 4.5-1.9 4.5-4.3V5.3C18 2.9 16 1 13.5 1h-8zm8 18h-8c-3 0-5.5-2.4-5.5-5.3V5.3C0 2.4 2.5 0 5.5 0h8c3 0 5.5 2.4 5.5 5.3v8.3c-.1 3-2.5 5.4-5.5 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 6c-.9 0-1.7.3-2.3 1C6.4 7.6 6 8.5 6 9.5 6 11.4 7.6 13 9.5 13S13 11.5 13 9.5C13 7.3 11.7 6 9.4 6m.1 8C7 14 5 12 5 9.5c0-1.2.5-2.4 1.4-3.3.8-.8 2-1.2 3.1-1.2 2.8.1 4.5 1.8 4.5 4.5-.1 2.5-2 4.5-4.5 4.5M16 4c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1c.5 0 1 .4 1 1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 8c-.5 0-1-.4-1-1s.5-1 1-1 1 .4 1 1-.5 1-1 1zm-2 4.5c0 2-1.6 3.5-3.5 3.5S32 14.4 32 12.5c0-.9.4-1.9 1.1-2.6.6-.6 1.4-.9 2.3-.9h.1c2.2 0 3.5 1.3 3.5 3.5zm.5-9.5h-8c-3 0-5.5 2.4-5.5 5.3v8.3c0 3 2.4 5.3 5.5 5.3h8c3 0 5.5-2.4 5.5-5.3V8.3C45 5.4 42.5 3 39.5 3z"
  }))));
}
SvgInstagram.displayName = 'Instagram';
export default SvgInstagram;